module.exports = __webpack_public_path__ + "az.fa9c079d.svg";